import React from "react";
import heroBg from "../assets/blogs/blogs-hero.webp"; // Update filename if different
import "../styles/blogs.css";

import { Link } from "react-router-dom";

import blog01 from "../assets/blogs/blog-01.webp";
import blog02 from "../assets/blogs/blog-02.webp";
import blog03 from "../assets/blogs/blog-03.webp";
import blog04 from "../assets/blogs/blog-04.webp";

export default function FinancialTrendsHero() {
  return (
    <main className="main-section">
      <section className="trends-hero-section">
        <img src={heroBg} alt="" className="hero-bg-img" />
        <div className="hero-overlay" />
        <div className="hero-text-box">
          <h1 className="hero-title">
            Stay Updated With Latest Financial Trends
          </h1>
        </div>

        {/* Bottom right scroll-to-top icon */}
        <button
          className="scroll-top-fixed-btn"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          aria-label="Scroll to top"
        >
          <svg width="24" height="24" fill="none">
            <path
              d="M12 17V7M12 7l-5 5m5-5l5 5"
              stroke="#888"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </section>

      <section className="blog-section">
        <Link
          to="/blog/blog1"
          style={{ textDecoration: "none", color: "inherit" }}
        >
          <div className="blog-main-feature">
            <div className="blog-main-info">
              <h3>
                Why Having an Alternative Source of Income Is No Longer
                Optional.
              </h3>
              <p style={{ fontSize: "0.9em", opacity: 0.5 }}>
                Posted on 4 July, 2025{" "}
              </p>
              <p>
                <br />
                In the era of rising living costs, inflation, and global
                instability, having numerous streams of steady income is no
                longer a luxury, but a need.
              </p>
              <div
                style={{ fontSize: "0.85rem", opacity: 0.7, marginTop: "25px" }}
              >
                By Abhishek Bhatia, CFA
              </div>
            </div>
            <div className="blog-main-img-holder">
              <img src={blog01} alt="Finance 101" className="blog-main-img" />
              <div className="blog-main-img-fade"></div>
            </div>
          </div>
        </Link>

        <div className="blog-grid-row">
          <div className="blog-card">
            <Link
              to="/blog/blog2"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <div className="blog-card-info">
                <h4>What Does a Financial Planner Really Do?</h4>
                <p style={{ fontSize: "0.9em", opacity: 0.5 }}>
                  Posted on 4 July, 2025{" "}
                </p>
                <p>
                  <br />
                  It’s more than just investing your money. This is what I have
                  been doing for the last 10 years working with major financial
                  institutions and brokerage firms. When people hear the term
                  financial planner, they often picture someone who simply
                  tells...
                </p>
                <div className="author-name">By Pranav Rana, CFP </div>
              </div>
              <img src={blog02} alt="Blog2" className="blog-card-img" />
            </Link>
          </div>

          <div className="blog-card">
            <Link
              to="/blog/blog3"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <div className="blog-card-info">
                <h4>The Glass Floor of Finance</h4>
                <p style={{ fontSize: "0.9em", opacity: 0.5 }}>
                  Posted on 4 July, 2025{" "}
                </p>
                <p>
                  <br />A morning reflection from the mountains. It’s early.
                  quiet. The kind of quiet you only get in the hills when the
                  clouds hang low, and the air feels like a pause button. A cup
                  of coffee beside me, sun just cracking through the mist and
                  I’m thinking about...
                </p>
                <div className="author-name">By Nabarun Sen, Director </div>
              </div>
              <img src={blog03} alt="Blog3" className="blog-card-img" />
            </Link>
          </div>

          <div className="blog-card">
            <Link
              to="/blog/blog4"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <div className="blog-card-info">
                <h4>Dubai Real Estate 2025: A Market on the Rise.</h4>
                <p style={{ fontSize: "0.9em", opacity: 0.5 }}>
                  Posted on 4 July, 2025{" "}
                </p>
                <p>
                  <br />
                  The real-estate market in Dubai is not just expanding but
                  thriving. The city saw a record $89 billion in real estate
                  transactions in the first half of 2025 alone, thanks to strong
                  demand, growing investor confidence, and an unmatched...
                </p>
                <div className="author-name">
                  By Geetanjali Singh, Market Research{" "}
                </div>
              </div>
              <img src={blog04} alt="Blog4" className="blog-card-img" />
            </Link>
          </div>
        </div>
        <button className="blog-all-btn">
          See all stories{" "}
          <span style={{ fontSize: "1.15em", verticalAlign: "-2px" }}>
            &rarr;
          </span>
        </button>
        <br />
        <br />
      </section>
    </main>
  );
}
